import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/dashboard')({
  pendingComponent: () => <div>Loading /_app/dashboard...</div>,
  component: () => <div>Hello /_app/dashboard!</div>,
});
